module.exports = __webpack_public_path__ + "media/test2.334e6970.mp4";